var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpense = function SvgExpense(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M907.5 182H138.16a45.25 45.25 0 0 1 0-90.5H817A45.26 45.26 0 0 0 817 1H138.2C63.34 1 2.44 61.86 2.44 136.72v724a135.74 135.74 0 0 0 135.76 135.8h769.3A90.48 90.48 0 0 0 998 906V272.48A90.48 90.48 0 0 0 907.5 182M817 679.75a90.51 90.51 0 1 1 90.51-90.5 90.48 90.48 0 0 1-90.51 90.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpense);
export default ForwardRef;